<script setup lang="ts">
  import { mdiContentCopy } from "@mdi/js";
  import { computed } from "vue";
  import QrcodeVue from "qrcode.vue";
  import { useI18n } from "vue-i18n";
  import { useApiStore } from "@/stores/api";
  import { showToast } from "@/utils/toast";

  defineProps<{
    description?: string;
  }>();

  const api = useApiStore();
  const { t } = useI18n();

  const resumeUrl = computed(() => `${window.location.origin}/${api.insuranceCode}`);

  async function copyResumeLink() {
    try {
      await navigator.clipboard.writeText(resumeUrl.value);
      showToast.success({
        title: t("component.mediaDesktopHandoff.copyLinkSuccessTitle"),
        description: t("component.mediaDesktopHandoff.copyLinkSuccessDescription"),
      });
    } catch (error) {
      showToast.warning({
        title: t("component.mediaDesktopHandoff.copyLinkErrorTitle"),
        description: t("component.mediaDesktopHandoff.copyLinkErrorDescription"),
      });
    }
  }
</script>

<template>
  <div class="media-desktop-handoff">
    <p class="page-title mb-2">
      {{ $t("component.mediaDesktopHandoff.title") }}
    </p>

    <p v-if="description" class="mb-4">
      {{ description }}
    </p>

    <QrcodeVue :value="resumeUrl" :size="220" />

    <div class="d-flex align-center ga-2 mt-4">
      <p class="text-caption mb-0">{{ $t("component.mediaDesktopHandoff.qrHelperText") }}</p>
      <v-btn
        :icon="mdiContentCopy"
        variant="text"
        size="20"
        class="pa-0"
        :aria-label="$t('component.mediaDesktopHandoff.copyLinkButton')"
        @click="copyResumeLink"
      />
    </div>
  </div>
</template>

<style scoped>
  .media-desktop-handoff {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 2rem 0;
  }
</style>
